import React from 'react';

const ResponseMsg2 = ({ message = '', status = '' }) => {
  if (!message) return null;

  return (
    <div
      className={`alert fw-semibold border-0 mt-2 ${
        status == 'success' ? 'alert-success' : 'alert-danger'
      }`}
    >
      {message}
    </div>
  );
};

export default ResponseMsg2;
